import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';

export const productDetailFlowContainerStyles: any = {
  flex: 1,
  width: '100%',
};

export const ProductDetailFlowContent = ({ style, ...props }: BoxProps) => (
  <Box {...props} style={[styles.productDetailFlowContent, style]} />
);

type ProductDetailFlowHeaderContainerProps = BoxProps & {
  backgroundColor?: string;
};

export const ProductDetailFlowHeaderContainer = ({
  backgroundColor,
  style,
  ...props
}: ProductDetailFlowHeaderContainerProps) => (
  <Box {...props} style={[styles.productDetailFlowHeaderContainer, { backgroundColor }, style]} />
);

const styles = StyleSheet.create({
  productDetailFlowContent: {
    flex: 1,
    width: '100%',
  },
  productDetailFlowHeaderContainer: {
    alignItems: 'center',
    height: 64,
    justifyContent: 'center',
    width: '100%',
  },
});
